import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=2fcfde4c&scoped=true"
import script from "./Nature.vue?vue&type=script&lang=js"
export * from "./Nature.vue?vue&type=script&lang=js"
import style0 from "./Nature.vue?vue&type=style&index=0&id=2fcfde4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfde4c",
  null
  
)

export default component.exports